import React from 'react';
import TranslatedComponent from '../../utils/TranslatedComponent';
import Success from '../messages/Success';
import Error from '../messages/Error';
import {sendClickback} from '../../actions/app';
import {secureReplace, callTealiumLink} from '../../utils/helpers';
import {constants} from "../../utils/constants";
import Parser from "html-react-parser";
import _ from 'lodash';

export class ClickBack extends React.Component  {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      numClicks: 0
    };

    this.handleSubmit = this.handleSubmit.bind(this, props.dispatch);
    this.handleOneIdLink = this.handleOneIdLink.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleUnfocus = this.handleUnfocus.bind(this);

    this.emailSentElement = React.createRef();
  }

  handleSubmit(dispatch, event) {
    event.preventDefault();
    let email = this.state.email;
    this.setState({
      ...this.state,
      numClicks: this.state.numClicks + 1
    });

    if (this.state.numClicks >= 5) {
      //no op
    } else {
      email = _.trim(email);
      dispatch(sendClickback(email));
      callTealiumLink({event_name: 'linkClick', link_category: 'login', 'link_name': 'Clickback' });
    }
  }

  handleOneIdLink(event) {
    event.preventDefault();
    callTealiumLink({event_name: 'linkClick', link_category: 'oneIdWeb', 'link_name': 'Login' });
    window.did.launchLogin()
    // this API returns a Promise object (thenable)
    // the first function passed to then() is success(data)
    .then(function(data){
      // If the sign in button has been clicked stop scrolling
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
      document.getElementById('scrollContainer').className += " stopScrolling";
      // the second function is an error handler (optional)
    }).fail(function(error){
      console.log("Looks like there was a problem launching login. ", error);
    });
  }

  handleKeyPress(event) {
    if (event.which === 13) {
      this.handleOneIdLink(event);
    }
  }

  handleUnfocus(event) {
    let stateObj = {
      ...this.state,
      'email': event.target.value
    };
    this.setState(stateObj);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.hasClickbackSuccess && this.state.numClicks > 0 && this.state.numClicks < 5) {
      let opacity = 0.1;
      let element = this.emailSentElement.current;
      //fade in
      let fadeInTimer = setInterval(function(){
        if (opacity >= 1){
          clearInterval(fadeInTimer);
          //wait
          let waitTimer = setTimeout(function () {
            //fade out
            let op = 1;  // initial opacity
            let fadeOutTimer = setInterval(function () {
              if (op <= 0.1){
                clearInterval(fadeOutTimer);
              }
              element.style.opacity = op;
              op -= 0.1;
            }, 100);
          }, 100);
        }
        element.style.opacity = opacity;
        opacity +=  0.1;
      }, 15);
    }
  }

  render() {
    let message = '';
    let msg = '';
    let limitTxt = '';
    if (this.props.hasClickbackSuccess && !this.props.hasClickbackFailure) {
      msg = secureReplace(this.translate('successHeadline'), 'email', this.props.email);
      if (this.state.numClicks >= 5) {
        limitTxt = secureReplace(this.translate('resendEmailLimitReached'), 'guestServicesLinkA', `<a id="errorGuestServicesLink" href="${constants.customerServiceHref}" target='_blank'>`);
        limitTxt = Parser(secureReplace(limitTxt, 'guestServicesLinkB', `</a>`));
      } else {
        limitTxt = <a onClick={this.handleSubmit}>{this.translate('resetEmailCommand')}</a>;
      }
      message = (<div className='centeredText'>
          <Success message={msg}/>
          <p className='description all top'>{this.translate('clickbackSuccessMessage')}</p>
          <p className='description all top'>{this.translate('resendEmailPrompt')}</p>
          <p className='description all bottom'>{limitTxt}</p>
          <p id='emailSent' ref={this.emailSentElement} style={{opacity: 1}}>
            <svg width="20px" height="14px" viewBox="0 0 32 32" aria-labelledby='Success Icon' role='img'>
              <title id='successIconTitle'>Success Icon</title>
              <circle id="successOval" cx="16" cy="16" r="16"></circle>
              <path
                d="M21.4585054,11.2479834 L15.4804104,17.3381524 C15.1553583,17.6689283 14.6298855,17.6689283 14.3056755,17.3381524 L10.6307344,13.5947161 C10.3141034,13.2715539 9.80294636,13.2630942 9.47621007,13.5752587 L8.26273846,14.7317056 C7.9200022,15.0590976 7.91158116,15.6098269 8.24337007,15.9482166 L13.6976766,21.5045758 C14.3452544,22.1644358 15.3962,22.1652818 16.0446199,21.5062678 L23.7557647,13.6683159 C24.0732378,13.3459996 24.0825009,12.8248795 23.7759751,12.4915656 L22.6517665,11.2674408 C22.330925,10.9188994 21.7902943,10.9095936 21.4585054,11.2479834"
                id="successIcon"></path>
            </svg>
            <span id='emailSentText'>Email Sent</span>
          </p>
      </div>);
    } else if (this.props.hasClickbackFailure) {
      msg = secureReplace(this.translate('errorMessage'), 'email', this.props.email);
      msg = secureReplace(msg, 'guestServicesLinkA', `<a id="errorGuestServicesLink" href="${constants.customerServiceHref}" target='_blank'>`);
      msg = secureReplace(msg, 'guestServicesLinkB', `</a>`);
      message = <Error code={msg} message={''} />;
    }

    return (
      <span>
        <div className='clickBackContainer'>
          <h1 className='emailPreferencesTitle'>{this.translate('pageTitle')}</h1>
          {message}
          <span hidden={this.props.hasClickbackSuccess && !this.props.hasClickbackFailure}>
            <p className='sectionDescription anonymous'>{this.translate('introCopyA')}</p>
            <label id='clickBackInputLabel anonymous' htmlFor='clickBackInput' className='inputLabel'>{this.translate('introCopyB')}</label>
            <input id='clickBackInput' type='text' className='text-input' placeholder={this.translate('fieldLabel')} onChange={this.handleUnfocus} />
            <button id='clickBackSubmit' className='clickBackButton' onClick={this.handleSubmit}>{this.translate('clickbackSubmit')}</button>
            <a id='oneIdSignInLink' tabIndex='0' onKeyPress={this.handleKeyPress} onClick={this.handleOneIdLink}>{this.translate('secondaryControl')}</a>
          </span>
        </div>
      </span>
    );
  }
}

TranslatedComponent(ClickBack);
export default ClickBack;



// WEBPACK FOOTER //
// ./client/src/components/userActions/ClickBack.jsx